import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Input, Wrapper, Label } from "../Panel";
import { AppState } from "../../../../../../stateManager/store";
import { updateElement } from "../../../../../../stateManager/store/formCreation_v2/actions";

export const DefaultPropsAsset = () => {
  const dispatch = useDispatch();
  const { selectedElementId, components } = useSelector(
    (state: AppState) => state.formJson
  );
  const component = components[selectedElementId];

  const handleChange = (path: string, value: string | number | boolean) => {
    dispatch(
      updateElement({
        id: selectedElementId,
        path,
        value,
      })
    );
  };

  return (
    <div>
      <Wrapper key="assetBindPrefix">
        <Label id="assetBindPrefix" label="Asset Bind Prefix" />
        <Input
          id="assetBindPrefix"
          type="text"
          value={component?.assetBindPrefix}
          placeholder="Enter asset bindprefix"
          onChange={(value: any) => {
            handleChange(`assetBindPrefix`, value);
          }}
        />
      </Wrapper>
      <Wrapper key="assetInstanceId">
        <Label id="assetInstanceId" label="Asset Instance Id" />
        <Input
          id="assetInstanceId"
          type="text"
          value={component?.assetInstanceId}
          placeholder="Enter asset instance id"
          onChange={(value: any) => {
            handleChange(`assetInstanceId`, value);
          }}
        />
      </Wrapper>
    </div>
  );
};
